import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import languageVersions from 'src/languageVersions.json';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    backend: {
      loadPath: (lngs) => {
        const lang = lngs[0];
        const version = languageVersions[lngs[0]];

        return `/lang/${lang}.${version}.json`;
      },
      getVersion: (language) => {
        return languageVersions[language];
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
